import { render, staticRenderFns } from "./payment-gateway-windcave.vue?vue&type=template&id=6080ee39"
import script from "./payment-gateway-windcave.vue?vue&type=script&lang=ts"
export * from "./payment-gateway-windcave.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports